/**
 * SimpleGrid Component
 *
 * A themed wrapper around Mantine's SimpleGrid component.
 * Provides easy responsive grid layouts without explicit column spans.
 */

import { SimpleGrid as MantineSimpleGrid, SimpleGridProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedSimpleGridProps extends SimpleGridProps {}

const SimpleGrid = forwardRef<HTMLDivElement, ThemedSimpleGridProps>((props, ref) => (
  <MantineSimpleGrid ref={ref} {...props} />
));

SimpleGrid.displayName = 'SimpleGrid';

export default SimpleGrid;
